<template>
	<div class="con">
		<div>
			<van-divider dashed class="head-title">预约挂号</van-divider>
		</div>
		<div class="list" v-if="list.length > 0">
			<div v-for="(item,index) in list" :key="index" class="list-disp" @click="toDeta(index)">
				<div class="list-time">{{item.GZRQ}}</div>
				<div>
					<div class="more">余号:<span>{{item.TOTAL}}</span></div>
					<div class="afternoon">{{item.ZBLB == 1 ? '上午' : '下午'}}</div>
				</div>
			</div>
			
		</div>
		<div class="noImg" v-if="noImgShow == false">
			<img src="../assets/404.gif" />
			<div class="no-text">医生无排班时间~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'collectionRegistered',
		data() {
			return {
				msg: '通讯录',
				showIndex: 0,
				list: [],
				cardUserInfo: '',
				noImgShow: true,
				doctorUser:{},
				
			}
		},
		methods: {
			//获取个人医生排班时间
			GetMsYszbSj() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/collect/getMsYszbSj?ysdm=' + this.doctorUser.YGDM + '&ksdm=' + this.doctorUser.KSDM, null).then(res => {
					this.$store.commit('Load', false)
					console.log(res)
					if (res.code == 0) {
						if (res.msg.length != 0) {
							this.noImgShow = true;
							this.list = res.msg;
						} else {
							this.noImgShow = false;
						}

					} else {
						this.noImgShow = false;
					}
				}).catch(err => {
					this.$toast("网络出错")
					this.$store.commit('Load', false)
					this.noImgShow = false;
					console.log(err)
				})
			},
			//去挂号
			toDeta(e){
				let list = this.list[e];
				list.ksdm = this.doctorUser.KSDM;
				list.ksmc = '';//科室名称
				let currentMonth = this.currentMonth;
				
				list.chooseTime = this.list[e].GZRQ;
				this.$store.commit('dUser', list)
				
				this.$router.push({
					path: '/regConfirmation',
				})
			},
		},
		mounted() {
			this.GetMsYszbSj();
			
		},
		created() {
			console.log(JSON.parse(this.$route.query.doctor))
			this.doctorUser = JSON.parse(this.$route.query.doctor)
		}
	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;

	}

	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.head-title {
		font-size: 16px;
		color: #27BEC4;
		font-weight: 700;
	}

	.head-title span {
		color: #27BEC4;
		font-size: 18px;
		font-weight: 700;
	}

	.list {
		flex: 1;
		overflow-y: auto;
	}

	.list-disp {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		padding: 15px 10px;
		margin: 0 10px;
	}

	.more{
		font-size: 14px;
		color: #000000;
	}
		
	.more span{
		font-size: 24px;
		font-weight: 700;
		color: #27BEC4;
	}
	.afternoon{
		margin-top: 10px;
		font-size: 14px;
		color: #666;
	}
</style>
